const siteEligibilityLocale = {
  siteEligibility: {
    pageTitle: "Eligibilité",
    cardTitle: "Modification des critères d'éligibilité du site pour les CEE",
    yes: "Oui",
    no: "Non",
    isBuildingMoreThan2YearsOld: "Bâtiment résidentiel existant depuis plus de 2 ans ?",
    areAllHeatersWired: "L'ensemble des radiateurs est raccordé",
    isNotPro: "Site particulier",
    hasNoSiteHeatPump: {
      title: "Pompe a chaleur présente sur le site (installée ou non)",
      none: "Aucune",
      atLeastOne: "Au moins une",
      unqualifiedWarning:
        "Pompe à chaleur déclarée par l'adhérent, sans marque ni modèle. Renseignez-les pendant l'appel, ou cochez « Aucune » si l'adhérent n'en a pas.",
      qualifyButton: "Renseigner la marque et le modèle",
    },
    back: "Retour",
    submit: "Enregistrer",
    escUpgradeModal: {
      title: "Eligibilité à la vente",
      siteIsUpgradeable:
        "Ce site est désormais éligible à la vente. Un nouveau package documentaire doit être envoyé a l'adhérent",
      cta: "Basculer sur une vente",
    },
  },
};

export type SiteEligibilityLocale = typeof siteEligibilityLocale;
export default siteEligibilityLocale;
